export function isAdminRole (user) {
    return user.company_id ===1
}

export function isRegister (user) {
    return user.master_user_id ===1
}

//Capitalize the first letter of each word in a string
export function firstLetetrUpperOfString(str = '', separator = " "){
    // const str = 'i have learned something new today';

    //split the above string into an array of strings 
    //whenever a blank space is encountered<<<<<<<<saADFSGDHFJGKGFHDGFSEDA

    const arr = str.split(`${separator}`);

    //loop through each element of the array and capitalize the first letter.


    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

    }

    //Join all the elements of the array back into a string 
    //using a blankspace as a separator 
    const str2 = arr.join(" ");
    return str2

    //Outptut: I Have Learned Something New Today
}

 export function convertNumberStringToInternationalNumberSystem(numberInString){
	let parts = numberInString.split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || ''; // If no decimal part, default to empty string
    
    // Format integer part
    let formattedInteger = '';
    let count = 0;
    
    for (let i = integerPart.length - 1; i >= 0; i--) {
        formattedInteger = integerPart[i] + formattedInteger;
        count++;
        
        // Add comma or period every three digits
        if (count % 3 === 0 && i !== 0) {
            formattedInteger = ',' + formattedInteger; // You can change ',' to '.' for different locales
        }
    }
    
    // Combine integer part and decimal part (if exists)
    let formattedNumber = formattedInteger + (decimalPart ? '.' + decimalPart : '');
    
    return formattedNumber;
}


export function isServiceCenter (user) {
    return user.company_id ===333
}